/**
 * Builds a display-friendly full name from a user's first and last name.
 *
 * @param {{firstName?: string, lastName?: string}} user - The user object.
 * @returns {string} The full name, the first name alone, or 'User' if neither is available.
 */
export default function getFullName(user) {
  const firstName = user?.firstName || '';
  const lastName = user?.lastName || '';

  if (firstName && !lastName) return firstName;

  const fullName = `${firstName} ${lastName}`.trim();
  return fullName || 'User';
}
